import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import React from 'react';

export const NURTURING_PLAN_EXECUTION_TEST = 'test_plan_day';

const BLOCKED_STATUSES = new Set([
  // 'future',
  'not_launched',
  'COMPLETED',
  'RUNNING',
  'completed',
  'running',
]);

const getDisabledReason = (status: string | undefined): string | null => {
  const normalized = String(status ?? '').trim();
  if (!normalized) return null;
  // if (normalized === 'future') return 'Plan day is in the future';
  if (normalized === 'not_launched') return 'Dealer has not launched yet';
  if (normalized === 'COMPLETED' || normalized === 'completed') {
    return 'Plan day already completed';
  }
  if (normalized === 'RUNNING' || normalized === 'running') {
    return 'Plan day is currently running';
  }
  return null;
};

const isTestableRow = (status: string | undefined): boolean => {
  const normalized = String(status ?? '').trim();
  if (!normalized) return true;
  return !BLOCKED_STATUSES.has(normalized);
};

interface CellNurturingPlanExecutionActionsProps {
  params: any;
  onClick: (params: any, clickedElement: string) => void;
}

const CellNurturingPlanExecutionActions = ({
  params,
  onClick,
}: CellNurturingPlanExecutionActionsProps) => {
  const executionStatus = params?.row?.execution_status;
  const isTesting = Boolean(params?.row?.__testing);
  const canTest = isTestableRow(executionStatus);
  const disabledReason = getDisabledReason(executionStatus);
  const tooltip = isTesting
    ? 'Starting test run...'
    : canTest
      ? 'Run test for this plan day'
      : disabledReason || 'Cannot run test for this plan day';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Tooltip title={tooltip}>
        <span>
          <IconButton
            size="small"
            aria-label="run nurturing plan day test"
            disabled={!canTest || isTesting}
            onClick={e => {
              e.stopPropagation();
              onClick(params, NURTURING_PLAN_EXECUTION_TEST);
            }}
            sx={{ padding: 0.5 }}
          >
            {isTesting ? (
              <CircularProgress size={16} thickness={5} />
            ) : (
              <PlayArrowIcon fontSize="small" />
            )}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default CellNurturingPlanExecutionActions;
